import { Button, Flex, FormControl, FormLabel, Heading, Input, useToast } from "@chakra-ui/react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { baseUrl } from "../../Redux/App/app.actions";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const toast = useToast({
    position: "bottom-right",
    isClosable: true,
    duration: 3000,
  });
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const checkIfEmailIsValid = () => {
    // console.log(email);
    if (!email) {
      toast({
        title: "Please enter email",
        status: "error",
      });
      return false;
    }
    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let isValid = emailRegex.test(String(email).toLowerCase());
    // check if email id is of ripik.in or sunpharma.com domain
    if (!isValid) {
      toast({
        title: "Please enter valid email",
        status: "error",
      });
      return false;
    }
    const emailDomain = email.split("@")[1];
    if (emailDomain !== "ripik.in" && emailDomain !== "sunpharma.com" && emailDomain !== "ripik.ai") {
      isValid = false;
      toast({
        title: "Please enter valid domain",
        status: "error",
      });
    }
    return isValid;
  };

  const handleSubmit = async () => {
    if (!checkIfEmailIsValid()) {
      return;
    }
    setLoading(true);
    // call api to send email to user and redirect to login page
    try {
      const url = `${baseUrl}/v1/user/forgot-password/`;
      const data = {
        email,
      };
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      if (result.message === "success") {
        toast({
          title: "Email sent successfully",
          description: "Please check your email for reset password link",
          status: "success",
          isClosable: true,
          duration: 10000,
        });
        navigate("/login");
      } else {
        toast({
          title: "Something went wrong",
          status: "error",
        });
      }
    } catch (err) {
      toast({
        title: "Something went wrong",
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <Flex
        flexDir="column"
        gap="5"
        my="10"
        borderRadius="10"
        bgColor="white"
        p="10"
        w={["95%", "90%", "60%", "50%"]}
        alignItems="center"
        justifyContent="center"
      >
        <Heading>Forgot Password?</Heading>
        <FormControl w={["100%", "90%", "80%", "60%"]} isRequired>
          <FormLabel textTransform="capitalize">Enter your email id</FormLabel>
          <Input type="email" placeholder="john.doe@example.com" value={email} onChange={handleChange} />
          <Flex mt="5">
            <Button
              colorScheme="green"
              variant="solid"
              mx="auto"
              isLoading={loading}
              onClick={() => {
                handleSubmit();
              }}
              textTransform="uppercase"
            >
              Submit
            </Button>
          </Flex>
        </FormControl>
      </Flex>
    </AuthLayout>
  );
};

export default ForgotPassword;
